import { render, staticRenderFns } from "./CardContent.vue?vue&type=template&id=6018f2f2&"
import script from "./CardContent.vue?vue&type=script&lang=js&"
export * from "./CardContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6018f2f2')) {
      api.createRecord('6018f2f2', component.options)
    } else {
      api.reload('6018f2f2', component.options)
    }
    module.hot.accept("./CardContent.vue?vue&type=template&id=6018f2f2&", function () {
      api.rerender('6018f2f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CardListBuilder/CardContent.vue"
export default component.exports